type Defined<T> = T extends undefined ? never : T;

export function isDefined<T>(value: T): value is Defined<T> {
    return value !== undefined;
}

type Number<T> = T extends number ? T : never;

export function isNumber<T>(value: T): value is Number<T> {
    return typeof value === 'number';
}

export type EnumToInterface<E extends Record<string, any>, T> = {
    [K in keyof E]: E[K] extends T ? K : never;
}[keyof E] extends infer U
    ? U extends keyof E
    ? E[U] extends T
    ? Record<U, E[U]>
    : never
    : never
    : never;

export function getSearchParamsFromStartupMsg(paramKey: string) {
    if (typeof window === 'undefined') {
        return '';
    }
    const urlObj = new URL(window.location.href);
    const startupMsg = JSON.parse(urlObj.searchParams.get('startupMsg') || '{}');
    return startupMsg?.[paramKey];
}

export function isInIframe() {
    return window.self !== window.top;
}


export function removeUrlParameter(paramKey: string) {
    const canAccessParent = isInIframe() && isSameOriginWithParent();
    const url = new URL(canAccessParent ? window.parent.location.href : window.location.href);
    url.searchParams.delete(paramKey);
    if (canAccessParent) {
        window.parent.history.pushState({}, '', url);
    } else {
        window.history.pushState({}, '', url);
    }
}


export function getProjectId() {
    let projectId: string = '';
    try {
        const searchParams = getParentSearchParamsSafe();
        projectId = searchParams.get('projectid') || '';
    } catch (e) {
        // fallback: try current window
        const matchResult = window.location.search.match(/projectid=([^&=]*)(&|$)/i);
        projectId = matchResult ? matchResult[1] : '';
    }
    return projectId;
}

// Safely check same-origin with parent without throwing on cross-origin access
export function isSameOriginWithParent(): boolean {
    try {
        // Accessing parent.location.origin throws if cross-origin; wrap in try/catch
        return !!window.parent && window.parent.location.origin === window.location.origin;
    } catch (_) {
        return false;
    }
}

// Safely get parent's origin using document.referrer; fallback to self origin
export function getParentOriginSafe(): string {
    try {
        if (document.referrer) {
            const u = new URL(document.referrer);
            return u.origin;
        }
    } catch (_) {
        // ignore
    }
    return window.location.origin;
}

// Safely get parent's URLSearchParams using document.referrer; fallback to self
export function getParentSearchParamsSafe(): URLSearchParams {
    return new URL(window.location.href).searchParams;
}

export function replaceKggSiteDomain(url: string) {
    if (!url) return url;
    // 使用正则全局替换，并忽略协议 http/https
    const newUrl = url.replace(/kgg-site\.oss\.kuguanggao\.com/g, 'kggsiteoss.kuguanggao.com').replace(/^http:\/\//, 'https://');
    console.log(url, newUrl, 'originurl')
    return newUrl;
}